import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_brand_1cd99af4 from 'nuxt_plugin_brand_1cd99af4' // Source: ../plugins/brand.js (mode: 'all')
import nuxt_plugin_datadog_19a1b94a from 'nuxt_plugin_datadog_19a1b94a' // Source: ../plugins/datadog.js (mode: 'client')
import nuxt_plugin_datadogrumtracker_bce8a09a from 'nuxt_plugin_datadogrumtracker_bce8a09a' // Source: ../plugins/datadog-rum-tracker.js (mode: 'client')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_weightconverter_12786801 from 'nuxt_plugin_weightconverter_12786801' // Source: ../plugins/weight-converter (mode: 'all')
import nuxt_plugin_mixins_9ca86422 from 'nuxt_plugin_mixins_9ca86422' // Source: ../plugins/mixins.js (mode: 'all')
import nuxt_plugin_urlbuilder_1eb1de27 from 'nuxt_plugin_urlbuilder_1eb1de27' // Source: ../plugins/urlBuilder/url-builder.js (mode: 'all')
import nuxt_plugin_helpcenterurlbuilder_36a7efbd from 'nuxt_plugin_helpcenterurlbuilder_36a7efbd' // Source: ../plugins/helpCenterUrlBuilder/help-center-url-builder.js (mode: 'all')
import nuxt_plugin_countryselect_f44f6d64 from 'nuxt_plugin_countryselect_f44f6d64' // Source: ../plugins/country-select.js (mode: 'all')
import nuxt_plugin_vuejsmodal_a01fef9e from 'nuxt_plugin_vuejsmodal_a01fef9e' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_countrydetector_5d3ed184 from 'nuxt_plugin_countrydetector_5d3ed184' // Source: ../plugins/country-detector.js (mode: 'all')
import nuxt_plugin_appHead_0579f2a8 from 'nuxt_plugin_appHead_0579f2a8' // Source: ../plugins/appHead.js (mode: 'all')
import nuxt_plugin_image_4703be3d from 'nuxt_plugin_image_4703be3d' // Source: ../plugins/images/image.js (mode: 'all')
import nuxt_plugin_icon_2c80c986 from 'nuxt_plugin_icon_2c80c986' // Source: ../plugins/images/icon.js (mode: 'all')
import nuxt_plugin_upsellsequence_f7d211a8 from 'nuxt_plugin_upsellsequence_f7d211a8' // Source: ../plugins/upsell-sequence.js (mode: 'all')
import nuxt_plugin_setLanguageCookie_2f150ccf from 'nuxt_plugin_setLanguageCookie_2f150ccf' // Source: ../plugins/setLanguageCookie.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Reverse Health","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology"},{"name":"format-detection","content":"telephone=no"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"pbnzferzi10qee09g49f28pcvhvgbz"},{"name":"p:domain_verify","content":"e095f9f9f36a7bdbfb89fbd6c4e1a766"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Freverse.health\u002F"},{"hid":"og:title","property":"og:title","content":"Reverse Health"},{"hid":"og:description","property":"og:description","content":"Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology."}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fbalance-text\u002F3.3.0\u002Fbalancetext.min.js","defer":true,"body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@300;400;500;600;700&family=Lora:wght@300;400;500;600;700&family=Lato:wght@300;400;500;600;700&family=Dosis:wght@600&family=Kanit:wght@600&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"link":[{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@300;400;500;600;700&family=Lora:wght@300;400;500;600;700&family=Lato:wght@300;400;500;600;700&family=Dosis:wght@600&family=Kanit:wght@600&display=swap"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@300;400;500;600;700&family=Lora:wght@300;400;500;600;700&family=Lato:wght@300;400;500;600;700&family=Dosis:wght@600&family=Kanit:wght@600&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_brand_1cd99af4 === 'function') {
    await nuxt_plugin_brand_1cd99af4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadog_19a1b94a === 'function') {
    await nuxt_plugin_datadog_19a1b94a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogrumtracker_bce8a09a === 'function') {
    await nuxt_plugin_datadogrumtracker_bce8a09a(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_weightconverter_12786801 === 'function') {
    await nuxt_plugin_weightconverter_12786801(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_9ca86422 === 'function') {
    await nuxt_plugin_mixins_9ca86422(app.context, inject)
  }

  if (typeof nuxt_plugin_urlbuilder_1eb1de27 === 'function') {
    await nuxt_plugin_urlbuilder_1eb1de27(app.context, inject)
  }

  if (typeof nuxt_plugin_helpcenterurlbuilder_36a7efbd === 'function') {
    await nuxt_plugin_helpcenterurlbuilder_36a7efbd(app.context, inject)
  }

  if (typeof nuxt_plugin_countryselect_f44f6d64 === 'function') {
    await nuxt_plugin_countryselect_f44f6d64(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_a01fef9e === 'function') {
    await nuxt_plugin_vuejsmodal_a01fef9e(app.context, inject)
  }

  if (typeof nuxt_plugin_countrydetector_5d3ed184 === 'function') {
    await nuxt_plugin_countrydetector_5d3ed184(app.context, inject)
  }

  if (typeof nuxt_plugin_appHead_0579f2a8 === 'function') {
    await nuxt_plugin_appHead_0579f2a8(app.context, inject)
  }

  if (typeof nuxt_plugin_image_4703be3d === 'function') {
    await nuxt_plugin_image_4703be3d(app.context, inject)
  }

  if (typeof nuxt_plugin_icon_2c80c986 === 'function') {
    await nuxt_plugin_icon_2c80c986(app.context, inject)
  }

  if (typeof nuxt_plugin_upsellsequence_f7d211a8 === 'function') {
    await nuxt_plugin_upsellsequence_f7d211a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setLanguageCookie_2f150ccf === 'function') {
    await nuxt_plugin_setLanguageCookie_2f150ccf(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
